module.exports = __webpack_public_path__ + "Roboto-Thin.44b78f142603eb69f593.woff";


//////////////////
// WEBPACK FOOTER
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/assets/fonts/roboto/Roboto-Thin.woff
// module id = ../../../../../src/assets/fonts/roboto/Roboto-Thin.woff
// module chunks = styles